import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { RootStoreState } from 'src/app/store';
import { EndorsementsSelectors } from '../../store';

@Component({
    selector: 'app-required-endorsement-count',
    templateUrl: './required-endorsement-count.component.html',
    styleUrls: ['./required-endorsement-count.component.scss'],
    standalone: false
})
export class RequiredEndorsementCountComponent implements OnInit {
  requiredEndorsementTotal$: Observable<number>;
  remainingRequiredEndorsementTotal$: Observable<number>;
  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.requiredEndorsementTotal$ = this.store.pipe(
      select(EndorsementsSelectors.selectActiveDocumentRequiredActions)
    );

    this.remainingRequiredEndorsementTotal$ = this.store.pipe(
      select(EndorsementsSelectors.selectActiveDocumentRemainingRequiredActions)
    );
  }
}
